import { EmptySubmission } from '../views/submissions/submissions-content/empty-submission';

export const EmptySubmissionRoute = () => {
  return <EmptySubmission />;
};
